import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import { getWebsitePageUrl } from '../../../../util/websiteLinks';

/**
 * Quick links in the app footer (ex CMS panel `footer-links`).
 * Kept in code so every enabled locale works without a CMS translation.
 */
function FooterAppLinks({ intl }) {
    const lang = intl.locale;

    const links = [
        {
            key: 'faq',
            href: getWebsitePageUrl('faq', lang),
            external: true,
            label: <FormattedMessage id="appFooterQuestion" defaultMessage="Got a question?" />,
        },
        {
            key: 'contact',
            href: getWebsitePageUrl('contact', lang),
            external: true,
            label: <FormattedMessage id="contactButton" defaultMessage="Contact us" />,
        },
        {
            key: 'terms',
            href: getWebsitePageUrl('terms', lang),
            external: true,
            label: <FormattedMessage id="appFooterTerms" defaultMessage="Terms of use" />,
        },
    ];

    return (
        <div>
            {links.map(link => (
                <div className="d-inline pt-2 me-2" key={link.key}>
                    <a
                        href={link.href}
                        target={link.external ? '_blank' : undefined}
                        rel={link.external ? 'noopener noreferrer' : undefined}
                        className="p-0 footer-link-lux"
                    >
                        {link.label}
                    </a>
                </div>
            ))}
        </div>
    );
}

FooterAppLinks.propTypes = {
    intl: PropTypes.object.isRequired,
};

export default injectIntl(FooterAppLinks);
